import type { VestiaireItemBadge, VestiaireSellerBadge } from '@/shared/api/types/generated';

// ============================================================================
// Valeurs d'un vestiaireFilter stocké — SOURCE UNIQUE partagée par le formulaire de recherche VC
// (features/productSearch/vestiaire) et la relance « articles similaires » (relaunchCriteria).
// Les enums générés sont des unions de chaînes, sans objet runtime : listes déclarées ici.
// ============================================================================

export const VESTIAIRE_SELLER_BADGES = ['expert', 'trusted'] as const satisfies readonly VestiaireSellerBadge[];

export const VESTIAIRE_ITEM_BADGES = [
  'vintage',
  'weLove',
  'exceptional',
  'dealEligible',
  'officialStore',
] as const satisfies readonly VestiaireItemBadge[];

/** Nombres d'une liste jsonb (valeurs d'un autre type écartées). */
export const numberList = (value: unknown): number[] =>
  Array.isArray(value) ? value.filter((v): v is number => typeof v === 'number') : [];

/** Chaînes d'une liste jsonb (valeurs d'un autre type écartées). */
export const stringList = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((v): v is string => typeof v === 'string') : [];

/** Badges vendeur connus d'une liste jsonb (valeur inconnue écartée). */
export const sellerBadgeList = (value: unknown): VestiaireSellerBadge[] =>
  Array.isArray(value)
    ? value.filter((v): v is VestiaireSellerBadge => (VESTIAIRE_SELLER_BADGES as readonly unknown[]).includes(v))
    : [];

/** Badges d'annonce connus d'une liste jsonb (valeur inconnue écartée). */
export const itemBadgeList = (value: unknown): VestiaireItemBadge[] =>
  Array.isArray(value)
    ? value.filter((v): v is VestiaireItemBadge => (VESTIAIRE_ITEM_BADGES as readonly unknown[]).includes(v))
    : [];
